import { TYPES_SOURCE_OPTIONS } from '@constants'

export const isObjectSource = (source: string | undefined) => {
  return source === TYPES_SOURCE_OPTIONS.OBJECT
}
